import { useEffect, useMemo, useRef, useState } from "react";
const useLargeListData = ({ fullData, batchSize = 20 }) => {
  const [page, setPage] = useState(1);
  const timeoutRef = useRef();
  const lastScrollPositionRef = useRef(0);
  const handleScroll = () => {
    clearTimeout(timeoutRef.current);
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollPosition > lastScrollPositionRef.current) {
      timeoutRef.current = setTimeout(() => {
        setPage((prev) => {
          if (prev * batchSize >= fullData.length) {
            return prev;
          }
          return prev + 1;
        });
      }, 50);
    }
    lastScrollPositionRef.current = currentScrollPosition;
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutRef.current);
      setPage(1);
    };
  }, [fullData]);
  const visibleData = useMemo(
    () => fullData.slice(0, page * batchSize),
    [page, fullData]
  );
  return { visibleData };
};
var stdin_default = useLargeListData;
export {
  stdin_default as default
};
